import React from "react";
import styled from "styled-components";
import SettingWrapper from "./Components/SettingWrapper";
import TextBearbeitung from "./Components/TextBearbeitungNeu";
import TextEingabe from "./Components/Texteingabe";
import FolientypAuswahl from "./Components/FolientypAuswahl";
import PriceCalculator from "./Components/PriceCalculator";
import SizeCalculator from "./Components/SizeCalculator";
import colors from "./data/colors.json";
import fontPaths from "./data/fontPaths.json";
import { prices, reducedVariants } from "./new-prices-20240411";

const fontBlacklist = [
  "Aladin-Regular",
  "Alba",
  "Alpha54",
  "Berliner-Wand",
  "BernerBasisschrift1",
  "Berolina",
  "Bitwise",
  "Blankenburg",
  "Bloody",
  "BoecklinsUniverse",
  "BombeCAT",
  "BubblerOne",
  "C-BOX",
  "CariocaScriptPro",
  "Chewy",
  "Classica-Bold",
  "Classica",
  "Courgette",
  "Damion-Regular",
  "Dogv2c",
  "GangOfThree",
  "LetsGoDigital",
  "Megadeth",
  "Nautilus",
  "Niconne",
  "OneTrickPony-OT",
  "PassionOne",
  "Playball",
  "PleasinglyPlump",
  "SpyAgency3",
  "Wolf4b",
  "Wolf4bi",
  "Xenogears",
];

const squareSvgStyle = {
  overflow: "visible",
  position: "relative",
  left: "10px",
  top: "100px", // Added 'px' to specify the unit
  height: "148px", // Added 'px' to specify the unit
};

const aufpreisFuerFarben = 5;

const Wrapper = styled.div`
  @media screen and (max-width: 768px) {
    padding-left: 0px;
    padding-right: 0px;
  }
`;

const Header = styled.div`
  display: flex;
  @media screen and (max-width: 768px) {
    flex-direction: column;
  }
`;

const HeaderImage = styled.img`
  width: 50%;
  @media screen and (max-width: 768px) {
    width: 100%;
  }
  height: auto;
  display: block;
`;

const HeaderText = styled.div`
  width: 50%;
  @media screen and (max-width: 768px) {
    width: 100%;
  }
  background: rgb(89, 113, 130);
  text-align: left;
  list-style-type: circle;
  color: #ffffff;
  padding: 32px;
  div {
    margin-bottom: 16px;
  }
  p {
    color: #ffffff;
    margin: 0 0 0 0;
  }
`;

const Main = styled.div`
  display: flex;
  flex-direction: row-reverse;
  margin-bottom: 20px;

  @media screen and (max-width: 768px) {
    flex-direction: column;
    padding-left: 0px;
    padding-right: 0px;
  }
`;

const SideBar = styled.div`
  width: 400px;
  @media screen and (max-width: 768px) {
    width: 100%;
  }
`;

const Content = styled.div`
  width: 100%;
`;

const ContentHeader = styled.div`
  background: rgb(89, 113, 130);
  padding-top: 12px;
  padding-bottom: 12px;
  display: flex;
  margin-bottom: 32px;
`;

const ContentView = styled.div`
  display: flex;
  // width: 800px;
  height: 500px;
  @media screen and (max-width: 768px) {
    height: ${({ dynamicHeight }) =>
      dynamicHeight ? `${dynamicHeight + 10}px` : "140px"};
  }
  pointer-events: none;
`;

const ButtonBox = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  flex: 1;
`;

export default class AppKlebeschriftenKonfiguratorNeu extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      opentypeFont: null,
      opentypeFonts: null,
      isOpentypeLoaded: false,
      isSmallScreen: window.innerWidth < 768,
      folienTyp: "Matt",
      hexcode: "#000000",
      fontSize: "212",
      textAlign: "left",
      zeilenabstand: -66,
      letterSpacing: 0,
      mirrowed: "",
      lastUserInputField: "hoehe",
      farbenAufpreis: 0,
      lastUserInput: 5,
      ratio: 5.934259202745226,
      dynamicHeight: "140px",
      svgHeight: 0,
      pathMeasures: [],

      width: 1,
      height: 1,

      menge: 1,
      colorPaletteOpen: false,
      preisError: false,
      errorText: "",
      warenkorbText: "",
      zeilen: [],
      zeilenInhalt: ["Folienhain.de"],
      anchor: "start",
      x: 0,
      fullInfo: [
        {
          text: "Dein Text",
          font: "Arimo",
          fontSuffix: "-Regular",
          color: "#000000",
          fontSize: "212",
          fontSizeInPx: "212px",
          lineHeight: 1,
          letterSpacing: 0,
          anchor: "start",
          x: -2000,
          y: 400,
        },
      ],
      aktiveZeile: 0,
      modal: false,
      modalText: 1,
      colorModalIsShown: false,
    };
    this.opentypeFont = this.handleResize.bind(this);
    this.opentypeFonts = this.handleResize.bind(this);
    this.isOpentypeLoaded = this.handleResize.bind(this);
    this.handleResize = this.handleResize.bind(this);
    this.reactFontPicker = this.reactFontPicker.bind(this);
    this.setFolientyp = this.setFolientyp.bind(this);
    this.setFontSize = this.setFontSize.bind(this);
    this.setTextAlign = this.setTextAlign.bind(this);
    this.setTextFormat = this.setTextFormat.bind(this);
    this.setLetterSpacing = this.setLetterSpacing.bind(this);
    this.setLineHeight = this.setLineHeight.bind(this);
    this.setInput = this.setInput.bind(this);
    this.setMenge = this.setMenge.bind(this);
    this.toggleMirror = this.toggleMirror.bind(this);
    this.handleChangeComplete = this.handleChangeComplete.bind(this);
    this.addToCart = this.addToCart.bind(this);
    this.updateRatio = this.updateRatio.bind(this);
    this.openColorPalette = this.openColorPalette.bind(this);
    this.setAktiveZeile = this.setAktiveZeile.bind(this);
    this.checkColors = this.checkColors.bind(this);
    this.resetColors = this.resetColors.bind(this);
    this.setModal = this.setModal.bind(this);
    this.openColorModal = this.openColorModal.bind(this);
    this.closeColorModal = this.closeColorModal.bind(this);
    this.toggleColorModal = this.toggleColorModal.bind(this);
    this.colorClicked = this.colorClicked.bind(this);
  }

  setAktiveZeile(zeile) {
    this.setState({ aktiveZeile: zeile });
    this.setState({
      hexcode: zeile === "0" ? "#000000" : this.state.fullInfo[zeile - 1].color,
    });
  }
  setModal() {
    this.setState({ modal: false });
  }
  openColorModal() {
    this.setState({ colorModalIsShown: true });
  }
  closeColorModal() {
    this.setState({ colorModalIsShown: false });
  }
  toggleColorModal() {
    this.setState({ colorModalIsShown: !this.state.colorModalIsShown });
  }
  colorClicked(color) {
    this.closeColorModal();
    this.handleChangeComplete(color);
    this.setState({ hexcode: color });
    this.updateRatio();
  }

  async generateSVG() {
    // 0000 Remove old elements
    const svg = document.getElementById("square-svg");
    const oldPathElements = svg.querySelectorAll("path");
    oldPathElements.forEach((path) => {
      path.remove();
    });
    svg.style.transform = null;

    // zeilenabstand
    let updatedFullInfo = [];
    console.log({ fullInfo: this.state.fullInfo });
    this.state.fullInfo.forEach((line, id) => {
      if (id !== 0) {
        const previousY = this.state.fullInfo[id - 1]?.y;
        const previousFontSize = parseInt(
          this.state.fullInfo[id - 0]?.fontSize
        );
        const currenctY =
          previousY + previousFontSize + this.state.zeilenabstand * 0.5;
        line.y = currenctY;
      }
      updatedFullInfo.push(line);
    });

    // create svg
    let fontPath;
    if (!this.state.opentypeFonts) {
      setTimeout(() => {
        this.generateSVG();
      }, 500);
      return;
    }

    updatedFullInfo.forEach((line, id) => {
      const lineCompare = fontBlacklist.includes(line.font)
        ? line.font
        : line.font + line.fontSuffix;

      console.log({ line, lineCompare });
      // DRAW THE TEXT LINE
      let currentFont = this.state.opentypeFonts.find(
        (item) => item.name === lineCompare
      );
      const font = currentFont?.font;
      console.log({ currentFont });
      fontPath = font.getPath(line.text, 0, 0, line.fontSize);
      fontPath.toPathData();
      const path = document.createElementNS(
        "http://www.w3.org/2000/svg",
        "path"
      );
      path.setAttribute("d", fontPath.toPathData());
      path.setAttribute("fill", line.color);
      path.setAttribute("stroke", "none");
      svg.appendChild(path);
    });

    // get widest
    const pathElements = document.querySelectorAll("#square-svg path");
    let pathMeasures = [];
    pathElements.forEach((path, index) => {
      pathElements[index].removeAttribute("transform");
      const boundingRect = path.getBoundingClientRect();
      const width = boundingRect.width;
      // get height for empty lines
      let lastValidHeight = null;
      for (let i = 0; i < pathElements.length; i++) {
        const boundingRect = pathElements[i].getBoundingClientRect();
        const currentHeight = boundingRect?.height;

        if (currentHeight) {
          lastValidHeight = currentHeight;
        }
      }

      const height = boundingRect.height || lastValidHeight;

      const x = boundingRect.x;
      const y =
        index === 0
          ? 0
          : pathMeasures[index - 1].y + pathMeasures[index - 1].height * 1.5; // fixiert die erste Zeile
      const pathMeasure = {
        width: width,
        height: height,
        x: x,
        y: y,
      };
      pathMeasures.push(pathMeasure);
    });

    const findWidestElement = (measures) => {
      let maxWidth = 0;
      let widestLine;
      measures.forEach((elem, id) => {
        if (elem.width > maxWidth) {
          maxWidth = elem.width;
          widestLine = { ...elem };
        }
      });
      return widestLine;
    };
    const widestLine = findWidestElement(pathMeasures);

    this.setState({ pathMeasures: pathMeasures });

    // calc height
    const filteredMeasures = pathMeasures.filter((item) => item.width !== 0);

    const lastItemInPathMeasures =
      filteredMeasures[filteredMeasures.length - 1];
    const svgWidth = widestLine?.width;
    const svgHeight = lastItemInPathMeasures.y + lastItemInPathMeasures.height;
    this.setState({ svgHeight: svgHeight });

    console.log({ svgWidth, svgHeight });

    let orientation;

    if (this.state.isSmallScreen) {
      orientation = svgHeight / svgWidth > 1 ? "portrait" : "landscape";
    } else {
      orientation = svgHeight / svgWidth > 0.625 ? "portrait" : "landscape";
    }

    console.log({ orientation });

    console.log({ isSmallScreen: this.state.isSmallScreen });

    let scaledFactor =
      document.getElementById("content-header").getBoundingClientRect().width /
      svgWidth;
    if (orientation === "portrait") {
      scaledFactor = (this.state.isSmallScreen ? 320 : 600) / svgHeight; // 600 for big
    }

    //transform + text align
    pathMeasures.forEach((measure, id) => {
      const xTransformFaktor = orientation === "portrait" ? 0 : 401;
      let translateX = null;
      const widestWidth = widestLine?.width;
      const ownWidth = measure.width;

      let minXValue = Infinity;
      pathMeasures.forEach((measurement) => {
        if (measurement.x < minXValue) {
          minXValue = measurement.x;
        }
      });
      const diff = minXValue - measure.x;
      const moveToLeft = diff * scaledFactor * 5.4;
      if (this.state.anchor === "start") {
        translateX = updatedFullInfo[id].x + 80 + moveToLeft;
      } else if (this.state.anchor === "middle") {
        translateX =
          (widestWidth / 2 - ownWidth / 2) * scaledFactor * 5.4 + moveToLeft;
      } else if (this.state.anchor === "end") {
        translateX = (widestWidth - ownWidth) * scaledFactor * 5.4 + moveToLeft;
      }
      pathElements[id].removeAttribute("transform");
      pathElements[id].setAttribute(
        "transform",
        `matrix(${scaledFactor},0,0,${scaledFactor},${translateX},${
          (updatedFullInfo[id].y - 401) * scaledFactor + xTransformFaktor
        })`
      );
    });

    const svgToTransform = document.getElementById("test");
    const svgToTransformMeasures = svgToTransform.getBoundingClientRect();
    const firstPathElement = document.querySelectorAll("#square-svg path")[0];
    const firstPathElementMeasures = firstPathElement?.getBoundingClientRect();
    let maxWidthElement = null;
    let maxWidth = 0;
    document.querySelectorAll("#square-svg path").forEach((path, id) => {
      const bbox = path.getBoundingClientRect();
      if (bbox.width > maxWidth) {
        maxWidth = bbox.width;
        maxWidthElement = id;
      }
    });

    const widestPathElement =
      document.querySelectorAll("#square-svg path")[maxWidthElement];
    const widestPathElementMeasures =
      widestPathElement?.getBoundingClientRect();
    const centerOfFrame = {
      x: svgToTransformMeasures.x + svgToTransformMeasures.width / 2,
      y: svgToTransformMeasures.y,
    };
    const centerOfPaths = {
      x: widestPathElementMeasures?.left + widestPathElementMeasures?.width / 2,
      y: firstPathElementMeasures.top,
    };
    const translation = {
      x: centerOfFrame.x - centerOfPaths.x,
      y: centerOfFrame.y - centerOfPaths.y,
    };

    // MARKUS WIP
    const drawGreyBox = () => {
      const redBox = document.getElementById("red-box");
      if (redBox) {
        redBox.parentNode.removeChild(redBox);
      } else {
        console.log("Red box not found.");
      }

      const div = document.createElement("div");
      const getAllElementsToCalcHeight =
        document.querySelectorAll("#square-svg path");
      const first = getAllElementsToCalcHeight[0]?.getBoundingClientRect();

      // LETS GO
      function findLastNonZeroHeightElement(arr) {
        for (let i = arr.length - 1; i >= 0; i--) {
          if (arr[i].getBoundingClientRect().height !== 0) {
            return i;
          }
        }
        return null; // Return null if no such element is found
      }

      function findMaxLeft(arr) {
        let maxLeft = 99999999;
        for (let i = arr.length - 1; i >= 0; i--) {
          if (arr[i]?.getBoundingClientRect().left < maxLeft) {
            maxLeft = arr[i]?.getBoundingClientRect().left;
          }
        }
        return maxLeft; // Return null if no such element is found
      }

      function findMaxRight(arr) {
        let maxRight = 0;
        for (let i = arr.length - 1; i >= 0; i--) {
          if (arr[i]?.getBoundingClientRect().right > maxRight) {
            maxRight = arr[i]?.getBoundingClientRect().right;
          }
        }
        return maxRight; // Return null if no such element is found
      }

      const lastId = findLastNonZeroHeightElement(getAllElementsToCalcHeight);
      const lastElem =
        getAllElementsToCalcHeight[lastId]?.getBoundingClientRect();

      const realHeight = lastElem?.top + lastElem?.height - first?.top;
      const textt = document.querySelectorAll("#square-svg path")[0];
      const textyMeasures = textt?.getClientRects();

      const xStart = findMaxLeft(getAllElementsToCalcHeight);
      const xEnd = findMaxRight(getAllElementsToCalcHeight);
      const calculatedWidth = xEnd - xStart;

      const wrapper = document.getElementById("test").getBoundingClientRect();

      // Set the styles for the div
      div.style.position = "absolute";
      div.style.top = textyMeasures.y + "px";
      div.style.left =
        findMaxLeft(getAllElementsToCalcHeight) - wrapper.x + "px";
      div.style.width = calculatedWidth + "px";
      div.style.height = realHeight + "px";
      div.style.background = "#F0F0F0";
      div.style.zIndex = "-1";

      // Append the div to the body
      document.getElementById("test").appendChild(div);

      div.style.transform = `translate(${0}px, ${
        first.y - div?.getBoundingClientRect().y
      }px)`;
      div.id = "red-box";
    };

    svgToTransform.style.transform = `translate(${translation.x}px, ${translation.y}px)`;

    drawGreyBox();

    const greyBox = document.getElementById("red-box");
    const measures = greyBox?.getClientRects();
    const ratio = measures[0].width / measures[0].height;
    // adjust height of box around svg
    this.setState({ dynamicHeight: measures[0].height });
    this.setState({ ratio: ratio });
  }

  // Functions for Sidebar START
  updateRatio() {
    // todo: remove unused code
    const elements = document.getElementsByClassName("mk-child");
    let arr = this.state.fullInfo;

    var elementToRemove = document.getElementById("mk-new-remove");

    // Check if the element exists before removing it
    if (elementToRemove) {
      // Remove the element from the DOM
      elementToRemove.remove();
    } else {
      console.log("Element with ID 'mk-new-remove' not found.");
    }

    while (elements.length <= this.state.fullInfo.length - 2) {
      arr.pop();
    }

    // todo: this has been changed from this.state.fullInfo.length - 1
    while (elements.length > this.state.fullInfo.length) {
      arr.push(arr[this.state.fullInfo.length - 1]);
    }

    const zeilen = [];
    const zeilenInhalt = [];
    for (let l = 0; l < elements.length; l++) {
      const count = l + 1;
      zeilen.push(count);
      let innerHTML = elements[l].innerHTML;
      innerHTML = innerHTML.replace(/<br>/g, "\u00A0");
      innerHTML = innerHTML.replace(/&lt;/g, "<");
      innerHTML = innerHTML.replace(/&gt;/g, ">");
      innerHTML = innerHTML.replace(/&nbsp;/g, "\u00A0");
      innerHTML = innerHTML.replace(/&amp;/g, "&");
      if (innerHTML.includes("<span")) {
        innerHTML = innerHTML.replace(/<\/?[^>]+(>|$)/g, "");
      }

      zeilenInhalt.push(innerHTML);
    }

    //text-aendern noetig????
    for (let j = 0; j < zeilenInhalt.length; j++) {
      let copiedObj = { ...arr[j] };
      copiedObj.text = zeilenInhalt[j];
      arr[j] = copiedObj;
    }
    const targetText = " ";

    const foundElement = arr.find((item) => item.text === targetText);

    if (arr.length !== zeilenInhalt.length && !foundElement) {
      const filteredArr = zeilenInhalt
        .map((val) => arr.find((item) => item.text === val))
        .filter((item) => item !== undefined);

      arr = filteredArr;
    }

    this.setState({ zeilen: zeilen });
    this.setState({ zeilenInhalt: zeilenInhalt });
    this.setState({ fullInfo: arr });

    let ratio;
    var svg = document.getElementById("mk-svg");

    const tspans = document.getElementsByClassName("mk-tspan");

    for (let i = 0; i < tspans.length; i++) {
      tspans[i].innerHTML = tspans[i].innerHTML.replace("&lt;/span&gt;", "");
      tspans[i].innerHTML = tspans[i].innerHTML.replace(/&lt;span.*"&gt;/, "");
    }

    const svgText = document.getElementById("mk-svg-text");

    const lineCount = this.state.fullInfo.length - 1;

    let meineHoehe = 0;
    let abstand = 0.8 + 0.1 * this.state.zeilenabstand;
    if (abstand < 1) {
      abstand = 1;
    }

    for (let i = 0; i < lineCount; i++) {
      let y = this.state.fullInfo[i].fontSize.replace("px", "");
      y = Number(y) * abstand;
      meineHoehe = meineHoehe + y;
    }

    if (tspans.length === 1) {
      const fontSizeInPX = Number(
        this.state.fullInfo[0].fontSize.replace("px", "")
      );
      ratio = tspans[0]?.getBBox().width / fontSizeInPX;

      this.setState({
        width: tspans[0]?.getBBox().width,
        height: meineHoehe,
      });
    } else {
      ratio = svgText?.getBBox().width / svgText?.getBBox().height;
      this.setState({
        width: svgText?.getBBox().width,
        height: meineHoehe,
      });
    }

    // Create an off-screen SVG element
    var offscreenSVG = document.createElementNS(
      "http://www.w3.org/2000/svg",
      "svg"
    );
    offscreenSVG.setAttribute("width", "0");
    offscreenSVG.setAttribute("height", "0");
    document.body.appendChild(offscreenSVG);

    // Create a text element within the off-screen SVG
    var textElement = document.createElementNS(
      "http://www.w3.org/2000/svg",
      "text"
    );
    textElement.textContent = "Dein Text";

    // Set font properties if needed
    textElement.setAttribute("font-family", "Arial");
    textElement.setAttribute("font-size", "26px");

    offscreenSVG.appendChild(textElement);

    // Get the bounding box of the text element
    var bbox = textElement.getBBox();

    // Remove the off-screen SVG element
    document.body.removeChild(offscreenSVG);

    // Calculate width and height
    var width = bbox.width;
    var height = bbox.height;

    this.generateSVG(); //wip
  }

  reactFontPicker(font) {
    const fullInfo = this.state.fullInfo;
    if (this.state.aktiveZeile == 0) {
      for (let i = 0; i < fullInfo.length; i++) {
        fullInfo[i].font = font;
      }
    } else {
      const zeile = this.state.aktiveZeile - 1;
      fullInfo[zeile].font = font;
    }
    this.setState({ fullInfo: fullInfo });
    setTimeout(() => {
      this.updateRatio();
    }, 1);
  }

  handleChangeComplete(color) {
    this.setState({ farbenAufpreis: 0 });
    const fullInfo = this.state.fullInfo;
    if (this.state.aktiveZeile == 0) {
      for (let i = 0; i < fullInfo.length; i++) {
        fullInfo[i].color = color;
      }
    } else {
      const zeile = this.state.aktiveZeile - 1;
      fullInfo[zeile].color = color;
    }

    this.checkColors(fullInfo);

    this.setState({ fullInfo: fullInfo });
  }

  checkColors(fullInfo) {
    // todo check fullInfo not lines length
    const farben = [];
    const lines = document.getElementsByClassName("mk-child");
    for (let j = 0; j < lines.length; j++) {
      farben.push(fullInfo[j].color);
    }
    const distinctFarben = [...new Set(farben)];

    // length > 1 5 EUR aufpreis
    if (distinctFarben.length > 1) {
      this.setState({ farbenAufpreis: aufpreisFuerFarben });
    }
    // length > 3 error
    if (distinctFarben.length > 3) {
      this.setState({
        preisError: true,
      });
      this.setState({
        errorText: `Nur 3 verschiedene Farben moeglich`,
      });
    } else if (
      this.state.errorText == `Nur 3 verschiedene Farben moeglich` &&
      distinctFarben.length <= 3
    ) {
      this.setState({
        preisError: false,
      });
      this.setState({
        errorText: ``,
      });
    }
  }

  setFontSize(e) {
    const fullInfo = this.state.fullInfo;
    if (this.state.aktiveZeile == 0) {
      for (let i = 0; i < fullInfo.length; i++) {
        fullInfo[i].fontSize = e.target.value.replace("px", "");
      }
    } else {
      const zeile = this.state.aktiveZeile - 1;
      fullInfo[zeile].fontSize = e.target.value.replace("px", "");
    }
    this.setState({ fullInfo: fullInfo });

    setTimeout(() => {
      this.updateRatio();
    }, 1);
  }

  setLetterSpacing(e) {
    const fullInfo = this.state.fullInfo;
    if (this.state.aktiveZeile == 0) {
      for (let i = 0; i < fullInfo.length; i++) {
        fullInfo[i].letterSpacing = e.target.value;
      }
    } else {
      const zeile = this.state.aktiveZeile - 1;
      fullInfo[zeile].letterSpacing = e.target.value;
    }
    this.setState({ fullInfo: fullInfo });

    setTimeout(() => {
      this.updateRatio();
    }, 1);
  }

  setFolientyp(folienTyp) {
    // if (folienTyp == "Matt" && (this.state.folienTyp == "Hochwertig" || this.state.folienTyp == "MattPremium")) {
    //   this.resetColors();
    // } else if (
    //   folienTyp == "Standard" &&
    //   (this.state.folienTyp == "Hochwertig" || this.state.folienTyp == "MattPremium")
    // ) {
    //   this.resetColors();
    // } else if (
    //   (folienTyp == "Hochwertig" || folienTyp == "MattPremium" ) &&
    //   this.state.folienTyp == "Standard"
    // ) {
    //   this.resetColors();
    // } else if ((folienTyp == "Hochwertig" || folienTyp == "MattPremium" ) && this.state.folienTyp == "Matt") {

    if (folienTyp === "Milchglas") {
      console.log("set to weißgrau");
      this.resetColors("#EDECEC");
    } else {
      this.resetColors("#000000");
    }
    // }
    this.setState({ folienTyp: folienTyp });
  }

  resetColors(color) {
    console.log({ fullInfo: this.state.fullInfo });
    // loop thru full info
    const arr = [...this.state.fullInfo];
    for (let i = 0; i < arr.length; i++) {
      arr[i].color = color;
    }
    this.setState({ fullInfo: arr });
    this.setState({
      hexcode: color,
    });
    this.updateRatio();
  }

  openColorPalette() {
    const palette = document.getElementById("color-palette");
    if (!this.state.colorPaletteOpen) {
      palette.classList.remove("hidden");
      this.setState({ colorPaletteOpen: true });
    } else {
      palette.classList.add("hidden");
      this.setState({ colorPaletteOpen: false });
    }
  }

  setTextAlign(e) {
    if (e.target.className.includes("left")) {
      this.setState({ textAlign: "left" });
      this.setState({ anchor: "start" });
      this.setState({ x: 0 });
    } else if (e.target.className.includes("center")) {
      this.setState({ textAlign: "center" });
      this.setState({ anchor: "middle" });
      this.setState({ x: "50%" });
    } else if (e.target.className.includes("right")) {
      this.setState({ textAlign: "right" });
      this.setState({ anchor: "end" });
      this.setState({ x: "100%" });
    }
    setTimeout(() => {
      this.updateRatio();
    }, 1);

    const active = document.getElementsByClassName("mk-active");
    if (active.length > 0) {
      active[0].classList.remove("mk-active");
    }
    e.target.classList.add("mk-active");
  }

  setTextFormat(e) {
    const className = e.target.className;

    const getNewFontSuffixStringForMultiLines = (string, className) => {
      let newString = string;

      const removeBold = (str) => {
        let returnString;
        if (str === "-Bold") {
          returnString = "-Regular";
        } else if (str === "-BoldItalic") {
          returnString = "-Italic";
        } else if (str === "-Italic") {
          returnString = "-Italic";
        } else if (str === "-Regular") {
          returnString = "-Regular";
        }
        return returnString;
      };

      const addBold = (str) => {
        let returnString;
        if (str === "-Bold") {
          returnString = "-Bold";
        } else if (str === "-BoldItalic") {
          returnString = "-BoldItalic";
        } else if (str === "-Italic") {
          returnString = "-BoldItalic";
        } else if (str === "-Regular") {
          returnString = "-Bold";
        }
        return returnString;
      };

      const removeItalic = (str) => {
        let returnString;
        if (str === "-Bold") {
          returnString = "-Bold";
        } else if (str === "-BoldItalic") {
          returnString = "-Bold";
        } else if (str === "-Italic") {
          returnString = "-Regular";
        } else if (str === "-Regular") {
          returnString = "-Regular";
        }
        return returnString;
      };

      const addItalic = (str) => {
        let returnString;
        if (str === "-Bold") {
          returnString = "-BoldItalic";
        } else if (str === "-BoldItalic") {
          returnString = "-BoldItalic";
        } else if (str === "-Italic") {
          returnString = "-Italic";
        } else if (str === "-Regular") {
          returnString = "-Italic";
        }
        return returnString;
      };

      if (className.includes("bold")) {
        if (className.includes("mk-format-active")) {
          newString = removeBold(newString);
        } else {
          newString = addBold(newString);
        }
      } else if (className.includes("italic")) {
        if (className.includes("mk-format-active")) {
          newString = removeItalic(newString);
        } else {
          newString = addItalic(newString);
        }
      }

      return newString;
    };

    const getNewFontSuffixString = (string, className) => {
      let newString = string;
      if (className.includes("bold")) {
        const active = document.getElementsByClassName("mk-bold");

        if (newString === "-Bold") {
          newString = "-Regular";
          active[0].classList.remove("mk-format-active");
        } else if (newString === "-BoldItalic") {
          newString = "-Italic";
          active[0].classList.remove("mk-format-active");
        } else if (newString === "-Italic") {
          newString = "-BoldItalic";
          e.target.classList.add("mk-format-active");
        } else if (newString === "-Regular") {
          newString = "-Bold";
          e.target.classList.add("mk-format-active");
        }
      } else if (className.includes("italic")) {
        const active = document.getElementsByClassName("mk-italic");

        if (newString === "-Bold") {
          newString = "-BoldItalic";
          e.target.classList.add("mk-format-active");
        } else if (newString === "-BoldItalic") {
          newString = "-Bold";
          active[0].classList.remove("mk-format-active");
        } else if (newString === "-Italic") {
          newString = "-Regular";
          active[0].classList.remove("mk-format-active");
        } else if (newString === "-Regular") {
          newString = "-Italic";
          e.target.classList.add("mk-format-active");
        }
      }
      return newString;
    };

    const fullInfo = this.state.fullInfo;
    if (this.state.aktiveZeile == 0) {
      for (let i = 0; i < fullInfo.length; i++) {
        fullInfo[i].fontSuffix = getNewFontSuffixStringForMultiLines(
          fullInfo[i].fontSuffix,
          className
        );
      }

      if (className.includes("active")) {
        e.target.classList.remove("mk-format-active");
      } else {
        e.target.classList.add("mk-format-active");
      }
    } else {
      const zeile = this.state.aktiveZeile - 1;
      fullInfo[zeile].fontSuffix = getNewFontSuffixString(
        fullInfo[zeile].fontSuffix,
        className
      );
    }

    this.setState({ fullInfo: fullInfo });

    setTimeout(() => {
      this.updateRatio();
    }, 1);
  }

  setLineHeight(e) {
    this.setState({ zeilenabstand: e.target.value });
    setTimeout(() => {
      this.updateRatio();
    }, 1);
  }

  checkPreisError(input, ratio, inputField) {
    let upperEnd = 400;
    let that = this;
    function setError(bool) {
      that.setState({ preisError: bool });
    }
    let opposite;
    if (inputField == "hoehe") {
      opposite = input * ratio;
    }
    if (inputField == "breite") {
      opposite = input / ratio;
    }
    let area = opposite * input;
    if (input < 1 || input > upperEnd || opposite < 1 || opposite > upperEnd) {
      this.setState({
        errorText: `Die Seitenlängen müssen zwischen 1 - ${upperEnd} cm liegen!`,
      });
      setError(true);
    } else if (area > 40000) {
      this.setState({
        errorText: "Die ausgewähle Fläche ist zu groß!",
      });
      setError(true);
    } else if (opposite > 120 && input > 120) {
      this.setState({
        errorText: "Nur eine der beiden Seiten darf über 120 cm groß sein!",
      });
      setError(true);
    } else {
      this.setState({ errorText: "" });
      setError(false);
    }
  }

  setInput(e) {
    this.setState({ lastUserInput: e.target.value });
    this.setState({ lastUserInputField: e.target.id });
    // this.checkPreisError(e.target.value, this.state.ratio, e.target.id);
  }

  setMenge(e) {
    this.setState({ menge: e.target.value });
  }
  // Functions for Sidebar END

  toggleMirror() {
    this.state.mirrowed === ""
      ? this.setState({ mirrowed: "flip" })
      : this.setState({ mirrowed: "" });

    setTimeout(() => {
      this.updateRatio();
    }, 1);
  }

  toggleModal(text) {
    this.setState({ modalText: text });
    this.setState({ modal: !this.state.modal });
  }

  addToCart() {
    const discounts = [
      { xOrMore: 2, discont: 0.25 },
      { xOrMore: 3, discont: 0.4 },
      { xOrMore: 5, discont: 0.45 },
      { xOrMore: 10, discont: 0.65 },
      { xOrMore: 25, discont: 0.7 },
      { xOrMore: 50, discont: 0.75 },
      { xOrMore: 100, discont: 0.8 },
      { xOrMore: 250, discont: 0.85 },
      { xOrMore: 500, discont: 0.9 },
    ];
    function getDiscount(x) {
      let discount = 0;

      for (let i = 0; i < discounts.length; i++) {
        if (x >= discounts[i]?.xOrMore) {
          discount = discounts[i]?.discont;
        } else {
          break;
        }
      }

      return discount;
    }

    const inputField = this.state.lastUserInputField;
    const input = this.state.lastUserInput;
    const ratio = this.state.ratio;
    let hoeheBerechnet = input / ratio;
    hoeheBerechnet = hoeheBerechnet.toFixed(1);
    let breiteBerechnet = input * ratio;
    breiteBerechnet = breiteBerechnet.toFixed(1);
    let hoehe = inputField === "breite" ? hoeheBerechnet : input;
    let breite = inputField === "hoehe" ? breiteBerechnet : input;
    let flaecheInCM = breite * hoehe;
    let flaeche = flaecheInCM / 10000;
    let preis;
    let priceWithoutDiscount;

    if (
      this.state.folienTyp === "Matt" ||
      this.state.folienTyp === "Standard" ||
      this.state.folienTyp === "Milchglas"
    ) {
      //y = -0,7121x4 + 7,1569x3 - 27,535x2 + 73,575x + 6,1129
      let a = 0.7121 * flaeche * flaeche * flaeche * flaeche;
      let b = 7.1569 * flaeche * flaeche * flaeche;
      let c = 27.535 * flaeche * flaeche;
      let d = 73.575 * flaeche;
      let e = 5.2629; // -0.85 wurde abgezogen
      // console.log("preis before: ", b - c + d + e - a);
      priceWithoutDiscount = b - c + d + e - a;
      preis =
        b -
        c +
        d +
        e -
        a -
        (b - c + d + e - a) * getDiscount(this.state?.menge);
      let counter = 0;
      let result = 6;
      (function () {
        for (let i = 0; i < prices.length; i++) {
          if (preis <= prices[i]) {
            result = i;
            return;
          }
          counter = counter + 1;
        }
      })();
      preis = prices[result];
      if (preis < 6 * getDiscount(this.state?.menge)) {
        preis = 6 * getDiscount(this.state?.menge);
      }
      //check
      let counter2 = 0;
      let result2 = 6;
      (function () {
        for (let i = 0; i < prices.length; i++) {
          if (priceWithoutDiscount <= prices[i]) {
            result2 = i;
            return;
          }
          counter2 = counter2 + 1;
        }
      })();
      priceWithoutDiscount = prices[result2];
      if (priceWithoutDiscount < 6) {
        priceWithoutDiscount = 6;
      }
    } else if (
      this.state.folienTyp === "Hochwertig" ||
      this.state.folienTyp === "MattPremium"
    ) {
      //y = 1,5873x3 - 15,106x2 + 75,658x + 8,4825
      let a = 1.5873 * flaeche * flaeche * flaeche;
      let b = 15.106 * flaeche * flaeche;
      let c = 75.658 * flaeche;
      let d = 7.2425; // -1.24 wurde abgezogen
      priceWithoutDiscount = a - b + c + d;
      preis = a - b + c + d - (a - b + c + d) * getDiscount(this.state?.menge);
      let counter = 0;
      let result = 8;
      (function () {
        for (let i = 0; i < prices.length; i++) {
          if (preis <= prices[i]) {
            result = i;
            return;
          }
          counter = counter + 1;
        }
      })();
      preis = prices[result];

      if (preis < 8 * getDiscount(this.state?.menge)) {
        preis = 8 * getDiscount(this.state?.menge);
      }

      let counter2 = 0;
      let result2 = 8;
      (function () {
        for (let i = 0; i < prices.length; i++) {
          if (priceWithoutDiscount <= prices[i]) {
            result2 = i;
            return;
          }
          counter2 = counter2 + 1;
        }
      })();
      priceWithoutDiscount = prices[result2];
      if (priceWithoutDiscount < 8) {
        priceWithoutDiscount = 8;
      }
    }

    const gesamtpreis = (preis + this.state.farbenAufpreis) * this.state.menge;
    const itemPrice = priceWithoutDiscount + this.state.farbenAufpreis;
    const discountPercentage = getDiscount(this.state.menge);
    const reducedItemPreis = itemPrice - itemPrice * discountPercentage;

    const svg = document.getElementById("square-svg");
    let gespiegelt = "Nein";
    if (this.state.mirrowed) {
      gespiegelt = "Ja";
    }

    console.log("MARKUS: ", {
      preis,
      reducedItemPreis,
      itemPrice,
      discountPercentage,
      menge: this.state.menge,
    });

    let variantId = null;
    let priceFoundInArray = null;
    prices.forEach((price, id) => {
      if (price >= reducedItemPreis && !variantId) {
        variantId = id;
        priceFoundInArray = price;
      }
    });

    // remove height width etc
    const clonedSvg = svg.cloneNode(true);

    // Remove the width and height attributes from the cloned SVG
    clonedSvg.removeAttribute("width");
    clonedSvg.removeAttribute("height");
    clonedSvg.removeAttribute("style");
    clonedSvg.setAttribute("viewBox", "0 -2000 1 20000");

    // Serialize the cloned SVG to a string
    const serializer = new XMLSerializer();
    const svgString = serializer.serializeToString(clonedSvg);

    // chang transform in paths

    // var serializedSVG = new XMLSerializer().serializeToString(svg);
    var base64Data = window.btoa(svgString);

    var b64 = "data:image/svg+xml;base64," + base64Data;
    // eslint-disable-next-line no-undef
    jQuery.post("/cart/add.js", {
      items: [
        {
          quantity: this.state.menge,
          id: reducedVariants[variantId],
          properties: {
            _SVG: b64,
            Textvorschau: this.state.fullInfo[0].text.substr(0, 29),
            Font: this.state.fullInfo[0].font,
            Farbe: !!colors[this.state.fullInfo[0].color.toUpperCase()]
              ? colors[this.state.fullInfo[0].color.toUpperCase()]
              : this.state.fullInfo[0].color.toUpperCase(),
            Größe: breite + " cm * " + hoehe + " cm",
            Gespiegelt: gespiegelt,
            Folientyp: this.state.folienTyp,
          },
        },
      ],
    });
    this.setState({
      warenkorbText: "Artikel wurde in den Einkaufswagen gelegt!",
    });
    setTimeout(() => {
      this.setState({
        warenkorbText: "",
      });
    }, 2000);
  }

  async componentDidMount() {
    // markus
    const loadFont = (fontPath) => {
      return new Promise((resolve, reject) => {
        opentype.load(fontPath.src, (err, font) => {
          if (err) {
            reject(err);
          } else {
            resolve({ font, name: fontPath.name });
          }
        });
      });
    };

    const loadFonts = async (paths) => {
      return Promise.all(paths.map(loadFont));
    };

    loadFonts(fontPaths)
      .then((loadedFonts) => {
        this.setState({ opentypeFonts: loadedFonts });
      })
      .catch((error) => {
        console.error("Error loading fonts:", error);
      });

    window.addEventListener("resize", this.handleResize);

    window.onbeforeunload = function (e) {
      e = e || window.event;

      // For IE and Firefox prior to version 4
      if (e) {
        e.returnValue = "Sure?";
      }

      // For Safari
      return "Sure?";
    };
    const that = this;
    document.getElementById("sample-eingabe")?.addEventListener(
      "input",
      function () {
        that.updateRatio();
      },
      false
    );

    this.updateRatio();
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
  }

  handleResize() {
    this.updateRatio();
    this.setState({ isSmallScreen: window.innerWidth < 768 });
  }

  render() {
    let aktiveZeilenNummer = this.state.aktiveZeile;
    if (aktiveZeilenNummer == 0) {
      aktiveZeilenNummer = 1;
    }

    const textEingeben = {
      title: "Text Eingeben",
      popupTitle: "Text Eingeben",
      popupDescription:
        'Hier kannst du deinen Text, auch mehrzeilig, wie gewohnt eingeben. Für eine neue Zeile benutze die "Enter" Taste.',
      element: (
        <TextEingabe
          text={this.state.text}
          color={this.state.color}
          fontSize={this.state.fontSize + "px"}
          letterSpacing={this.state.letterSpacing}
          mirrowed={this.state.mirrowed}
          zeilen={this.state.zeilen}
          zeilenInhalt={this.state.zeilenInhalt}
          zeilenabstand={this.state.zeilenabstand}
          yWerte={this.state.yWerte}
          fullInfo={this.state.fullInfo}
          fontsLoaded={this.state.opentypeFonts}
        />
      ),
    };

    const settings = [
      {
        title: "Text Eingeben",
        popupTitle: "Text Eingeben",
        popupDescription:
          'Hier kannst du deinen Text, auch mehrzeilig, wie gewohnt eingeben. Für eine neue Zeile benutze die "Enter" Taste.',
        element: (
          <TextEingabe
            text={this.state.text}
            color={this.state.color}
            fontSize={this.state.fontSize + "px"}
            letterSpacing={this.state.letterSpacing}
            // textAlign={this.state.textAlign}
            mirrowed={this.state.mirrowed}
            zeilen={this.state.zeilen}
            zeilenInhalt={this.state.zeilenInhalt}
            zeilenabstand={this.state.zeilenabstand}
            yWerte={this.state.yWerte}
            fullInfo={this.state.fullInfo}
            fontsLoaded={this.state.opentypeFonts}
          />
        ),
      },
      {
        title: "Art der Klebefolie",
        popupTitle: "Folientypen",
        popupDescription: "Standard 51 Farben (glänzend)",
        link: "https://www.folienhain.de/blogs/wissenswertes/folientypen",
        element: (
          <FolientypAuswahl
            setFolientyp={(folie) => this.setFolientyp(folie)}
          />
        ),
      },
      {
        title: "Abmessung der Folie",
        popupTitle: "Abmessung der Folie",
        popupDescription:
          "Hier wird das Gesamtmaß deines erstellten Aufklebers angezeigt inklusive aller erstellten Texte und Zeilen.",
        element: (
          <SizeCalculator
            ratio={this.state.ratio}
            lastUserInputField={this.state.lastUserInputField}
            lastUserInput={this.state.lastUserInput}
            preisError={this.state.preisError}
            menge={this.state.menge}
            folienTyp={this.state.folienTyp}
            setInput={this.setInput}
            setMenge={this.setMenge}
            errorText={this.state.errorText}
            farbenAufpreis={this.state.farbenAufpreis}
          />
        ),
      },
      {
        title: "Preis & Mengenrabatt",
        popupTitle: "",
        popupDescription: "",
        element: (
          <PriceCalculator
            ratio={this.state.ratio}
            lastUserInputField={this.state.lastUserInputField}
            lastUserInput={this.state.lastUserInput}
            preisError={this.state.preisError}
            menge={this.state.menge}
            folienTyp={this.state.folienTyp}
            setInput={this.setInput}
            setMenge={this.setMenge}
            errorText={this.state.errorText}
            farbenAufpreis={this.state.farbenAufpreis}
          />
        ),
      },
    ];
    return (
      <>
        <Header>
          <HeaderImage src="https://cdn.shopify.com/s/files/1/0026/9628/2210/files/Klebetext_auto-01.jpg?v=1701082716"></HeaderImage>

          <HeaderText>
            <h1>Klebeschriften erstellen</h1>
            <div>
              <p>• Hält auf allen glatten Untergründen</p>
              <p>• Buchstaben ausgeschnitten; ohne Hintergrund</p>
              <p>• Rückstandslos entfernbar</p>
              <p>• Perfekt für Autos, Schilder und vieles mehr.</p>
              <p>• UV- und witterungsbeständig</p>
              <p>• Einfache Montage mittels Transferfolie</p>
            </div>
          </HeaderText>
        </Header>
        {!this.state.isSmallScreen ? (
          <Main>
            <Content>
              <ContentHeader id="content-header">
                <TextBearbeitung
                  id="text-bearbeitung"
                  openColorPalette={this.openColorPalette}
                  handleChangeComplete={this.handleChangeComplete}
                  color={this.state.color}
                  setFontSize={this.setFontSize}
                  setTextAlign={this.setTextAlign}
                  setTextFormat={this.setTextFormat}
                  setLineHeight={this.setLineHeight}
                  setLetterSpacing={this.setLetterSpacing}
                  toggleMirror={this.toggleMirror}
                  reactFontPicker={this.reactFontPicker}
                  setAktiveZeile={this.setAktiveZeile}
                  toggleColorModal={this.toggleColorModal}
                  colorClicked={this.colorClicked}
                  colorModalIsShown={this.state.colorModalIsShown}
                  hexcode={this.state.hexcode}
                  zeilen={this.state.zeilen}
                  zeilenabstand={this.state.zeilenabstand}
                  fullInfo={this.state.fullInfo}
                  aktiveZeile={aktiveZeilenNummer}
                  folienTyp={this.state.folienTyp}
                  svgHeight={this.state.svgHeight}
                  pathMeasures={this.state.pathMeasures}
                  lastUserInputField={this.state.lastUserInputField}
                  lastUserInput={this.state.lastUserInput}
                  ratio={this.state.ratio}
                />
              </ContentHeader>{" "}
              <ContentView id="test" dynamicHeight={this.state.dynamicHeight}>
                <svg
                  width="400"
                  height="800"
                  viewBox="0 0 400 800"
                  // className={this.state.mirrowed}
                  id="square-svg"
                  style={squareSvgStyle}
                ></svg>
              </ContentView>
            </Content>
            <SideBar>
              {settings.map((setting, index) => {
                return (
                  <SettingWrapper
                    key={index}
                    title={setting.title}
                    popupTitle={setting.popupTitle}
                    popupDescription={setting.popupDescription}
                    popupElement={setting.popupElement}
                    link={setting.link}
                  >
                    {setting.element}
                  </SettingWrapper>
                );
              })}
              <ButtonBox>
                <div id="mk-warenkorb-text">
                  <p>{this.state.warenkorbText}</p>
                </div>
                <button
                  onClick={this.addToCart}
                  className="btn product-form__cart-submit w3-options-add-to-cart"
                  id="mk-cart-button"
                >
                  <span id="AddToCartText-product-template">
                    In den Einkaufswagen legen
                  </span>
                </button>
                <a
                  href="/cart"
                  className="btn product-form__cart-submit w3-options-add-to-cart mk-margin-top-44"
                  id="mk-cart-button"
                >
                  <span id="AddToCartText-product-template">
                    Zum Einkaufswagen
                  </span>
                </a>
              </ButtonBox>
            </SideBar>
          </Main>
        ) : (
          <Main>
            <SideBar>
              <SettingWrapper
                title={textEingeben.title}
                popupTitle={textEingeben.popupTitle}
                popupDescription={textEingeben.popupDescription}
                popupElement={textEingeben.popupElement}
              >
                {textEingeben.element}
              </SettingWrapper>
              {console.log("in template: ", this.state.dynamicHeight)}
              <ContentView id="test" dynamicHeight={this.state.dynamicHeight}>
                <svg
                  width="400"
                  height="800"
                  viewBox="0 0 400 800"
                  // className={this.state.mirrowed}
                  id="square-svg"
                  style={squareSvgStyle}
                ></svg>
                <p id="text"></p>
              </ContentView>
              <Content>
                <ContentHeader id="content-header">
                  <TextBearbeitung
                    id="text-bearbeitung"
                    openColorPalette={this.openColorPalette}
                    handleChangeComplete={this.handleChangeComplete}
                    color={this.state.color}
                    setFontSize={this.setFontSize}
                    setTextAlign={this.setTextAlign}
                    setTextFormat={this.setTextFormat}
                    setLineHeight={this.setLineHeight}
                    setLetterSpacing={this.setLetterSpacing}
                    toggleMirror={this.toggleMirror}
                    reactFontPicker={this.reactFontPicker}
                    setAktiveZeile={this.setAktiveZeile}
                    toggleColorModal={this.toggleColorModal}
                    colorClicked={this.colorClicked}
                    colorModalIsShown={this.state.colorModalIsShown}
                    hexcode={this.state.hexcode}
                    zeilen={this.state.zeilen}
                    zeilenabstand={this.state.zeilenabstand}
                    fullInfo={this.state.fullInfo}
                    aktiveZeile={aktiveZeilenNummer}
                    folienTyp={this.state.folienTyp}
                    svgHeight={this.state.svgHeight}
                    pathMeasures={this.state.pathMeasures}
                    lastUserInputField={this.state.lastUserInputField}
                    lastUserInput={this.state.lastUserInput}
                    ratio={this.state.ratio}
                  />
                </ContentHeader>
              </Content>

              <SideBar>
                {settings
                  .filter((setting) => setting.title !== textEingeben.title)
                  .map((setting, index) => {
                    return (
                      <SettingWrapper
                        key={index}
                        title={setting.title}
                        popupTitle={setting.popupTitle}
                        popupDescription={setting.popupDescription}
                        popupElement={setting.popupElement}
                        link={setting.link}
                      >
                        {setting.element}
                      </SettingWrapper>
                    );
                  })}
                <ButtonBox>
                  <div id="mk-warenkorb-text">
                    <p>{this.state.warenkorbText}</p>
                  </div>
                  <button
                    onClick={this.addToCart}
                    className="btn product-form__cart-submit w3-options-add-to-cart"
                    id="mk-cart-button"
                  >
                    <span id="AddToCartText-product-template">
                      In den Einkaufswagen legen
                    </span>
                  </button>
                  <a
                    href="/cart"
                    className="btn product-form__cart-submit w3-options-add-to-cart mk-margin-top-44"
                    id="mk-cart-button"
                  >
                    <span id="AddToCartText-product-template">
                      Zum Einkaufswagen
                    </span>
                  </a>
                </ButtonBox>
              </SideBar>
            </SideBar>
          </Main>
        )}
        {/* BOTTOM 1 */}
        <Wrapper>
          <div className="mk-bottom-1">
            <div>
              <h1>Echte Markequalität made in Germany</h1>
              <p>
                Wir produzieren unsere Aufkleber aus einer hochwertigen Folie,
                welche extra für den Außenbereich ausgelegt ist. Somit ist die
                Folie robust, langlebig(bis zu 10 Jahre), waschstraßenfest und
                rückstandslos entfernbar. Bei uns erhalten Sie zudem keine
                Lagerware, da wir unsere Aufkleber erst bei Bestellung
                produzieren.
              </p>
            </div>
            <img
              src="https://cdn.shopify.com/s/files/1/0026/9628/2210/files/folien_schmal-01_20ee463a-cbea-476a-a6be-d70d7a0ec678.jpg?v=1700655392"
              alt=""
            />
          </div>
          <div className="mk-bottom-1">
            <img
              src="https://cdn.shopify.com/s/files/1/0026/9628/2210/files/offnugnszeiten_folienaufbau-01-01.png?v=1700689236"
              alt=""
            />
            <div>
              <h1>Satte und volle Farben</h1>
              <p>
                Sie haben Auswahl aus einem großen Sortiment Folien. Es sind
                alle Standardfarben, einige Pastellfarben und 3 Farben in
                metallic erhältlich. Zudem können Sie sich zwischen matt und
                glänzend entscheiden.
              </p>
            </div>
          </div>
        </Wrapper>
        {/* BOTTOM 2 */}
        <div className="mk-bottom-2">
          <h1 style={{ fontWeight: 600, marginBottom: "2rem" }}>
            Häufige Fragen zu Klebeschriften
          </h1>
          <div>
            <div className="mk-bottom-2-1">
              <div className="mk-bottom-2-1-1">
                <h2>Wie werden die Klebebuchstaben geliefert?</h2>
                <p className="mk-p-80" style={{ color: "white" }}>
                  Die eigentliche Klebefolie liegt auf einem
                  silikonbeschichteten Papier. Über das Motiv ist eine
                  durchsichtige Transferfolie kaschiert, mit dieser Sie das
                  Motiv oder Klebeschrift auf den Untergrund anbringen können.
                </p>
              </div>
              <div className="mk-bottom-2-1-1">
                <h2>Was benötige ich für eine Montage der Klebeschrift?</h2>
                <p className="mk-p-80" style={{ color: "white" }}>
                  Für die Verklebung des Aufklebers benötigen Sie einen Rakel
                  (kann mitbestellt werden), alternativ können Sie ein Stofftuch
                  um eine Checkkarte wickeln und diese zu einer Anbringhilfe
                  umfunktionieren, Klebeband, fusselfreies Tuch, Wasserwaage,
                  Zollstock oder Maßband und genügend Zeit. Eine ausführliche
                  Verklebeanleitung finden Sie HIER
                </p>
              </div>
            </div>
            <div className="mk-bottom-2-1">
              <div className="mk-bottom-2-1-1">
                <h2>
                  Woher weiß ich, ob ein Untergrund zum bekleben geeignet ist?
                </h2>
                <p className="mk-p-80" style={{ color: "white" }}>
                  Klebe einen etwas längeren Tesafilmstreifen auf den
                  ausgewählten Untergrund. Hält der Streifen, wird auch die
                  Folie halten. Falls du dir dennoch nicht sicher bist, kannst
                  du einen kostenlosen Testaufkleber bestellen. Schreiben Sie
                  uns einfach eine Mail an{" "}
                  <a
                    style={{
                      color: "white",
                      textDecoration: "underline",
                    }}
                    href="mailto:info@folienhain.de"
                  >
                    info@folienhain.de
                  </a>
                </p>
              </div>
              <div className="mk-bottom-2-1-1">
                <h2>
                  Kann ich mit dem Aufkleber durch die Waschanlage fahren?
                </h2>
                <p className="mk-p-80" style={{ color: "white" }}>
                  Ja, unsere Klebebuchstaben sind waschstraßenfest!
                </p>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}
